import { useEffect, useState } from "react";
import AccessControl from "../functional/AccessControl";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import getSchema from "../../lib/api/getSchema";
import { useRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import { debounce } from 'lodash';
import UpdateRecordButton from "../input/UpdateRecordButton";
import CustomRecordButton from "../input/CustomRecordButton";

/**
 * @COMPONENT_NAME MenuSetManage
 * @DESCRIPTION 메뉴 세트를 관리하는 CRUD 화면 컴포넌트
 *
 * @PROPS 없음
 *
 * @CALLBACKS
 *    - {Function} onSuccess - 하위 버튼에서 복사 완료 시 호출되어 알림 메시지를 표시합니다.
 *    - {Function} onLoadData - 데이터가 로드될 때 호출되어 빈 목록 여부를 설정합니다.
 *    - {Function} onInitialized - 그리드 컴포넌트가 초기화될 때 호출되어 참조를 저장합니다.
 *    - {Function} onApiInitialized - API 객체가 초기화될 때 호출되어 참조를 저장합니다.
 * ```
 */

function MenuSetManage(props) {

    const [tableSchema, setTableSchema] = useState();

    const [grid, setGrid] = useState();
    const [api, setApi] = useState();

    const [, setIsEmpty] = useState();

    const [, setOnSelectMst] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    useEffect(() => {

        let mounted = true;

        (async () => {

            let schema = await getSchema("menuSet");

            for(let column of schema.columns){
                if(column.name === "description"){                    
                    column.readonly = true;
                }
            }

            schema.columns.push({
                formGroup : 0,
                formOrder: 2,
                name: "copyMenuSetName",
                required: true,
                type: "varchar(255)"
            })
            
            
            if (mounted) {
                setTableSchema(schema);
            }

        })();

        return (() => {
            mounted = false;
        });

    }, []);

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    };

    const onInitialized = (grid) => {

        setGrid(grid);

    };

    const onApiInitialized = (api) => {

        setApi(api);

    };

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0]);

                    }
                }, 10));

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0]);
                    }
                }, 10));
            }
        })();

    }, [grid]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    return (

        <BasicCrudScreenType
            id="MenuSet"
            table="MenuSet"
            view="MenuSet"
            onLoadData={onLoadData}
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            onAppendButtonAtFirst={() => (
                <>
                    <BasicCrudScreenActionItemLayout>
                        <AccessControl
                            accessTarget={tableSchema && tableSchema.name}
                            accessMethod="POST"
                        >
                            <CustomRecordButton
                                id="MenuSet"
                                mode="edit"
                                grid={grid}
                                refresh={api}
                                schema={tableSchema}
                                onSuccess={onSuccess}
                                modifyUrlCallback={()=>"/api/MenuSet/copy"}
                                
                                isFormData                            
                                color="primary"
                                buttonName="copy"
                                title="copy"
                            />
                        </AccessControl>
                    </BasicCrudScreenActionItemLayout>
                </>
            )}
        />
    );

}

export default MenuSetManage;
